import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import styles from "./Header.module.scss";

import { ReactComponent as UserBoldIcon } from "../assets/userBold.svg";
import { ReactComponent as HelpBoldIcon } from "../assets/helpBold.svg";
import { ReactComponent as BellBoldIcon } from "../assets/bellBold.svg";
import { ReactComponent as SearchIcon } from "../assets/search.svg";
import TooltipWrapper from "./tooltip/TooltipWrapper";
import { useModal } from "../stores/useModel";
import PlaceholderModal from "./model/PlaceholderModal";

type Props = {};

function Header({}: Props) {
  const [searchText, setSearchText] = useState("");
  const { setShowModal, setModalContent } = useModal(state => state);
  let history = useHistory();

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.iconWrapper}>
          <SearchIcon />
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();

            if (searchText) {
              history.push({
                pathname: "/search",
                search: `q=${searchText}`,
              });
            }
          }}
        >
          <input
            className={styles.input}
            type="text"
            placeholder="Search..."
            onChange={e => {
              setSearchText(e.target.value);
            }}
            value={searchText}
          />
        </form>
      </div>

      <div className={styles.right}>
        <TooltipWrapper tooltipText="Notifications" type="bottom">
          <div
            className={styles.iconWrapper}
            onClick={() => {
              setShowModal(true);
              setModalContent(
                <PlaceholderModal>Placeholder for Notifications</PlaceholderModal>
              );
            }}
          >
            <div className={styles.badge}>3</div>
            <BellBoldIcon />
          </div>
        </TooltipWrapper>

        <TooltipWrapper tooltipText="Get Help" type="bottom">
          <div
            className={styles.iconWrapper}
            onClick={() => {
              setShowModal(true);
              setModalContent(<PlaceholderModal>Placeholder for Help</PlaceholderModal>);
            }}
          >
            <HelpBoldIcon />
          </div>
        </TooltipWrapper>

        <TooltipWrapper tooltipText="Profile" type="bottom">
          <div
            className={styles.iconWrapper}
            onClick={() => {
              setShowModal(true);
              setModalContent(
                <PlaceholderModal>Placeholder for Profile</PlaceholderModal>
              );
            }}
          >
            <UserBoldIcon />
          </div>
        </TooltipWrapper>
      </div>
    </div>
  );
}

export default React.memo(Header);
